import {useTour} from "@reactour/tour";
import {Button, ColourSolid, FlexGap, Modal, ModalSize, StackVertical, useLayout} from "@twigsby/frontend-framework";
import React, {useEffect, useState} from "react";
import {useSite} from "../Providers/SiteInterfaceProvider";

const GuidedTour = (props: any) => {
    const { setOnboarding, onboardingActive, tourFinished } = useSite();
    const { setIsOpen } = useTour();

    const [ isOpen, setOpen ] = useState<boolean>(onboardingActive);

    const HandleClose = () => {
        setOnboarding(false);
        setOpen(false);
    }

    useEffect(() => {
        if(tourFinished) {
            setOpen(true);
        }
    }, [tourFinished]);

    useEffect(() => {
        setOpen(onboardingActive);
    }, [onboardingActive]);

    return (
        <>
            <Modal
                title={'Welcome to UK Postbox!'}
                isOpen={isOpen}
                closeCallback={() => setOpen(false)}
                lockOpen={true}
                modalSize={ModalSize.Medium}
                customContentWrapper={true}
            >
                <div className="card card-split guided-card">
                    <div className="card-body card-body-left">
                        <h4>Welcome to Your UK Postbox Account</h4>
                        <p>Some account info or verification status?</p>
                        <p>Include an onboarding checklist to the right instead?</p>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        <Button title={'View the Quick Tour'} fullWidth={true} extraClass={'mb-sm'} colour={ColourSolid.Primary} onClick={() =>
                            {
                                setOpen(false);
                                setIsOpen(true)
                            }}
                        />
                    </div>
                    <div className="card-body card-body-right flex-vertical-center primary text-center">
                        <StackVertical gap={FlexGap.ExtraSmall} extraClass={'p-lg'}>
                            <h5 className={'text-white'}>Need to get in Touch?</h5>
                            <Button title={'SendMailPage a Message'} fullWidth={true} />
                            <Button title={'Schedule a Callback'}  fullWidth={true} />
                        </StackVertical>
                    </div>
                </div>
                <div className={'overlay-custom-content-footer'}>
                    <Button title={'Close'} onClick={() => HandleClose()} />
                </div>
            </Modal>
        </>
    )
}

export { GuidedTour }
